import { CSSObject, MantineTheme } from "@mantine/core";

const AppTheme: Record<
  string,
  | Record<string, CSSObject>
  | ((theme: MantineTheme) => Record<string, CSSObject>)
> = {
  Anchor: {
    root: {
      color: "red",
    },
  },
  Badge: {
    root: {
      flexGrow: 0,
      alignItems: "center",
      padding: "6px 12px 5px",
      borderRadius: "32px",
    },
    inner: {
      flexGrow: 0,
      fontFamily: "Inter",
      fontSize: "11px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1,
      letterSpacing: " 0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
  },
  Drawer: {
    header: {
      margin: 0,
      padding: "2rem",
      backgroundColor: "#F7F7F8",
      fontSize: "1rem" /* 16px */,
      lineHeight: "1.5rem",
    },
    title: {
      flexGrow: 0,
      fontFamily: "Inter",
      fontSize: "18px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    closeButton: {
      borderLeftWidth: "1px",
      borderColor: "rgb(229 231 235)",
      backgroundColor: "#ffffff",
    },
  },
  Textarea: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
  },
  RadioGroup: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },

    radioWrapper: {
      label: {
        flexGrow: 0,
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.43,
        letterSpacing: "0.16px",
        padding: 0,
        textAlign: "left",
        color: "var(--grey-grey-80)",
      },
    },
    radio: {
      width: "16px",
      height: "16px",
      // margin: "2px 8px 2px 0",
      padding: "0 0 8px",
      // border: "solid 1px var(--grey-grey-50)",
      // backgroundColor: "var(--primary-primary-base)",
    },
  },
  MultiSelect: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  DateRangePicker: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  DatePicker: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  TimeInput: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  Modal: {
    modal: {
      display: "block",
      position: "relative",
      boxShadow:
        "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      borderRadius: "1.2rem",
      borderWidth: "1px",
      borderColor: "rgb(243 244 246)",
      overflow: "hidden",
      padding: "0px!important",
    },
    title: {
      color: "rgb(31 41 55)",
      fontSize: " 1.5rem" /* 24px */,
      lineHeight: 1.25,
      fontWeight: 700,
      letterSpacing: "0em",
    },
    close: {
      borderLeftWidth: "1px",
      borderColor: "rgb(229 231 235)",
      backgroundColor: "#ffffff",
    },
    body: {
      padding: "2rem",
    },
    header: {
      margin: 0,
      padding: "2rem",
      backgroundColor: "#F7F7F8",
      fontSize: "1rem" /* 16px */,
      lineHeight: "1.5rem",
    },
  },
  TextInput: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "inline-flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  Select: {
    label: {
      height: "24px",
      alignSelf: "stretch",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: " flex-start",
      alignItems: "flex-start",
      gap: "3px",
      padding: " 0 0 8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-80)",
    },
    description: {
      height: "16px",
      flexGrow: 1,
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "0.16px",
      textAlign: "left",
      color: "var(--grey-grey-70)",
    },
  },
  Button: {
    default: {
      height: "40px",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      padding: "12px 20px",
      borderRadius: "8px",
      backgroundColor: "var(--grey-grey-20)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "center",
      color: "var(--primary-primary-base)",
    },
    filled: {
      height: "40px",
      flexGrow: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      padding: "12px 20px",
      borderRadius: "8px",
      backgroundColor: "var(--primary-primary-base)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "0.16px",
      textAlign: "center",
      color: "var(--button-light-text)",
    },
  },
};

export default AppTheme;
